/***************************************************
 * Created by gongyanyu on 2023/3/28 17:43. *
 ***************************************************/
import { extendObservable, observable } from 'mobx';

export function initDataRef<S extends object, SK extends keyof S, T extends object>(
  source: S,
  key: SK,
  target: T,
  targetKey: string,
  defaultValue?: any,
): void {
  if (targetKey in target) {
    target[targetKey as keyof T] ??= defaultValue;
  } else {
    extendObservable(target, { [targetKey]: defaultValue }, { [targetKey]: observable });
  }

  delete source[key];

  Object.defineProperty(source, key, {
    configurable: true,
    get: () => target[targetKey as keyof T],
    set: (value: any) => void (target[targetKey as keyof T] = value),
  });
}

export function isRefCreator(fn: any): fn is Function {
  return typeof fn === 'function' && fn[`$$DataRefer`] === true;
}

export interface DataReferCreator {
  <S extends object, SK extends keyof S>(source: S, key: SK): void;

  $$DataRefer: true;
}

export function createDataRef<T extends object>(target: T, targetKey: string, defaultValue?: any): DataReferCreator {
  function fn<S extends object, SK extends keyof S>(source: S, key: SK) {
    return initDataRef(source, key, target, targetKey, defaultValue);
  }

  fn.$$DataRefer = true;

  return fn as DataReferCreator;
}
